var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusSmallest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4207 46.0465C27.4207 47.3777 28.4999 48.4569 29.8311 48.4569C31.1623 48.4569 32.2415 47.3777 32.2415 46.0465V31.5841H46.7038C48.035 31.5841 49.1142 30.505 49.1142 29.1737C49.1142 27.8425 48.035 26.7634 46.7038 26.7634H32.2415V12.301C32.2415 10.9698 31.1623 9.89062 29.8311 9.89062C28.4999 9.89062 27.4207 10.9698 27.4207 12.301V26.7633H12.9584C11.6271 26.7633 10.548 27.8425 10.548 29.1737C10.548 30.505 11.6271 31.5841 12.9584 31.5841H27.4207L27.4207 46.0465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSmallest);
export default __webpack_public_path__ + "static/media/plus-smallest.a703572977bb31c995389eacb4684f5c.svg";
export { ForwardRef as ReactComponent };